import { useOutletContext } from "react-router-dom";
import useStyles from "./styles";
import {
  Box,
  Divider,
  Grid,
  LinearProgress,
  Paper,
  Skeleton,
  Typography,
  Stack,
  Autocomplete,
  TextField,
  Tooltip,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";

import StatusComponent from "../../../../components/statusComponent";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import DatagridComponent from "../../../../components/datagridComponent";
import CardGraphComponent from "../../../../components/cardGraphComponent";
import CardDataComponent from "../../../../components/overview/cardDataComponent";
import DataGraphComponent from "../../../../components/overview/dataGraphComponent";
import CardStatusComponent from "../../../../components/overview/cardStatusComponent";
import LineChartComponent from "../../../../components/lineComponent";
//icons
import OpenDns from "../../../../assets/imgs/imagesCard/openDnsLogo.png";
import Globo from "../../../../assets/imgs/imagesCard/globoLogo.png";
import Ntp from "../../../../assets/imgs/imagesCard/ftntp-client.svg";
import CloudFlare from "../../../../assets/imgs/imagesCard/cloudLogo.png";
import google from "../../../../assets/imgs/imagesCard/googleLogo.png";
import {
  DownloadOutlined,
  NetworkPing,
  PublishOutlined,
  SpeedOutlined,
  TrendingDownOutlined,
  SettingsEthernetOutlined,
  CloseOutlined,
} from "@mui/icons-material";
import dayjs from "dayjs";
import clsx from "clsx";

import SeverityChip from "../../../../components/severityChip";

const DESTINO_IMAGE_MAP = {
  google: google,
  "open dns": OpenDns,
  cloudflare: CloudFlare,
  ntp: Ntp,
  globo: Globo,
};

function getDestinoImage(description) {
  const key = description?.toLowerCase()?.trim();
  return DESTINO_IMAGE_MAP[key] || null;
}

const INVERSED_POWER_RX =
  window?.config?.REACT_APP_INVERSED_POWER_RX ||
  process.env.REACT_APP_INVERSED_POWER_RX;

export default function OverviewClient() {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [errorPacketCount, setErrorPacketCount] = useState({
    in: 0,
    out: 0,
  });
  const [trafficNow, setTrafficNow] = useState({
    in: "0 KB/s",
    out: "0 KB/s",
  });

  const [loadingDashOverview, setLoadingDashOverview] = useState({
    trafficIn: false,
    trafficOut: false,
    statusInterface: false,
    erroPacketIn: false,
    erroPacketOut: false,
    speed: false,
    ping: false,
    packetLoss: false,
    latency: false,
    alerts: false,
    sessoesAtivas: false,
  });

  const [trafficInput, setTrafficInput] = useState([]);
  const [trafficOutput, setTrafficOutput] = useState([]);
  const [statusInterface, setStatusInterface] = useState(true);
  const [speedNow, setSpeedNow] = useState("0 KB/s");
  const [rows, setRows] = useState([]);
  const [pingDestinos, setPingDestinos] = useState([]);
  const [pingHabilitado, setPingHabilitado] = useState(null);
  const [packetLoss, setPacketLoss] = useState([]);

  const [latency, setLatency] = useState([]);
  const [sessoesAtivas, setSessoesAtivas] = useState([]);

  // estados do modal de histórico de ping por destino
  const [pingModalOpen, setPingModalOpen] = useState(false);
  const [pingModalDestino, setPingModalDestino] = useState(null);
  const [pingHistoryData, setPingHistoryData] = useState({
    latency: [],
    packetLoss: [],
  });
  const [pingHistoryLoading, setPingHistoryLoading] = useState({
    latency: false,
    packetLoss: false,
  });
  // indica se o usuário fez zoom manual — congela a sincronização com o pai
  const [pingModalZoomed, setPingModalZoomed] = useState(false);

  const {
    filterData,
    handleAplicarZoom,

    setCounter,
    setLoadingCronometro,
    selectTime,
    optionsTime,
    startCronometro,
    controllerDashboard,
    setControllerDashboard,
    toggleDrawer,
    apiCliente,
    stopCronometro,
    deviceConfig,
  } = useOutletContext();

  const clearData = () => {
    setErrorPacketCount({ in: 0, out: 0 });
    setTrafficNow({ in: "0 KB/s", out: "0 KB/s" });
    setTrafficInput([]);
    setTrafficOutput([]);
    setStatusInterface(true);
    setSpeedNow("0 KB/s");
    setRows([]);
    setPingDestinos([]);
    setPingHabilitado(null);
    setPacketLoss([]);
    setLatency([]);
    setSessoesAtivas([]);
    setOnu({});
    setOnuPower({});
    setSelectedOnu(null);
    // limpa o modal de histórico de ping ao trocar dispositivo/filtros
    setPingModalOpen(false);
    setPingModalDestino(null);
    setPingHistoryData({ latency: [], packetLoss: [] });
    setPingHistoryLoading({ latency: false, packetLoss: false });
    setPingModalZoomed(false);
  };

  useEffect(() => {
    if (!controllerDashboard) return;
    return controllerDashboard.abort();
  }, []);

  const columns = [
    {
      field: "alert",
      headerName: "Alerta",
      flex: 2,
      cellClassName: (params) => {
        return clsx("super-app", {
          onGoing: !params?.row?.recoveryDate,
        });
      },
      valueFormatter: (params) => params?.replaceAll('"', ""),
    },
    {
      field: "severity",
      headerName: "Severidade",
      flex: 1,
      renderCell: (params) => (
        <SeverityChip severity={params?.row?.severity} theme={theme} />
      ),
    },
    {
      field: "initialDate",
      headerName: "Horário Ocorrência",
      flex: 1.5,
      cellClassName: (params) => {
        return clsx("super-app", {
          onGoing: !params?.row?.recoveryDate,
        });
      },
      valueFormatter: (params) =>
        dayjs.unix(Number(params)).format("DD/MM/YYYY HH:mm:ss"),
    },
    {
      field: "recoveryDate",
      headerName: "Horário Recuperação",
      flex: 1.5,
      cellClassName: (params) => {
        return clsx("super-app", {
          onGoing: !params?.row?.recoveryDate,
        });
      },
      valueFormatter: (params) => {
        if (!params) {
          return "-";
        }
        return dayjs.unix(Number(params)).format("DD/MM/YYYY HH:mm:ss");
      },
    },
    {
      field: "duration",
      headerName: "Duração",
      flex: 1,
      cellClassName: (params) => {
        return clsx("super-app", {
          onGoing: !params?.row?.recoveryDate,
        });
      },
      valueFormatter: (params) => {
        const totalMs = Number(params);
        if (!params || isNaN(totalMs) || totalMs <= 0) {
          return "";
        }
        const yearMs = 31536000000;
        const monthMs = 2592000000;
        const dayMs = 86400000;
        const hourMs = 3600000;
        const minuteMs = 60000;
        const secondMs = 1000;

        let remaining = totalMs;
        const years = Math.floor(remaining / yearMs);
        remaining %= yearMs;

        const months = Math.floor(remaining / monthMs);
        remaining %= monthMs;

        const days = Math.floor(remaining / dayMs);
        remaining %= dayMs;

        const hours = Math.floor(remaining / hourMs);
        remaining %= hourMs;

        const minutes = Math.floor(remaining / minuteMs);
        remaining %= minuteMs;

        const seconds = Math.floor(remaining / secondMs);

        const parts = [];
        if (years > 0) parts.push(`${years}a`);
        if (months > 0) parts.push(`${months}mes`);
        if (days > 0) parts.push(`${days}d`);
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}m`);
        if (seconds > 0) parts.push(`${seconds}s`);

        return parts.join(" ");
      },
    },
  ];
  function formatTraffic(valueInBytesPerSecond) {
    const KB = 1000;
    const MB = KB * 1000;
    const GB = MB * 1000;

    const value = Number(valueInBytesPerSecond);

    if (value < MB) {
      return `${(value / KB).toFixed(1)} KB/s`;
    } else if (value < GB) {
      return `${(value / MB).toFixed(2)} MB/s`;
    } else {
      return `${(value / GB).toFixed(2)} GB/s`;
    }
  }
  function formatPing(valueInSeconds) {
    return `${(Number(valueInSeconds) * 1000).toFixed(0)} ms`;
  }
  function formatSessions(value) {
    if (value == null || isNaN(Number(value))) return "0";
    return Number(value).toLocaleString("pt-BR");
  }
  function formatPowerValue(value) {
    if (value === null || value === undefined || value === "") return "0 dBm";
    const num = Number(value);
    if (isNaN(num)) return `${value} dBm`;
    return `${INVERSED_POWER_RX ? -num.toFixed(0) : num.toFixed(0)} dBm`;
  }

  const getSessoesAtivas = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, sessoesAtivas: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          hostids: filterData?.hostId,
          nameFilter: "sessoesAtivas",
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );
      setSessoesAtivas(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal?.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, sessoesAtivas: false }));
      }
    }
  };

  const getDataTrafegoInput = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, trafficIn: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "trafficIn",
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );
      setTrafficInput(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, trafficIn: false }));
      }
    }
  };
  const getDataTrafegoInputNow = async (dateInitial, finalDate, signal) => {
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "trafficIn",
          lastItem: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );

      setTrafficNow((prev) => ({
        ...prev,
        in: formatTraffic(response?.data?.value || 0),
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  const getDataTrafegoOutputNow = async (dateInitial, finalDate, signal) => {
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "trafficOut",
          lastItem: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );
      setTrafficNow((prev) => ({
        ...prev,
        out: formatTraffic(response?.data?.value || 0),
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  };
  const getDataTrafegoOutput = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, trafficOut: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "trafficOut",
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );
      setTrafficOutput(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, trafficOut: false }));
      }
    }
  };
  const getStatusInterface = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, statusInterface: true }));
    try {
      const [response, itemsResponse] = await Promise.all([
        apiCliente.post(
          "/cliente/zabbix/serieTemporal",
          {
            device: filterData?.device,
            initial_date: dateInitial,
            final_date: finalDate,
            interface: filterData?.interfaceId,
            hostids: filterData?.hostId,
            nameFilter: "statusInterface",
            lastItem: true,
            fabricante: filterData?.fabricante,
            funcao: filterData?.funcao,
            modelo: filterData?.modelo,
            dash: "overview",
          },
          { signal },
        ),
        apiCliente.post(
          "/client/items/list",
          {
            hostid: filterData?.hostId,
            searchItemName: `Status da Interface ${filterData?.interfaceId}*`,
          },
          { signal },
        ),
      ]);

      const items = itemsResponse?.data?.items;
      if (!items || items.length === 0) {
        setStatusInterface(null);
      } else {
        setStatusInterface(
          response?.data?.value === 1 || response?.data?.value === "1"
            ? true
            : false,
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, statusInterface: false }));
      }
    }
  };
  const getErrorPacketIn = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, erroPacketIn: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "erroPacketIn",
          lastItem: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );

      setErrorPacketCount((prev) => ({
        ...prev,
        in: response?.data?.value || 0,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, erroPacketIn: false }));
      }
    }
  };
  const getErrorPacketOut = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, erroPacketOut: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "erroPacketOut",
          lastItem: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );

      setErrorPacketCount((prev) => ({
        ...prev,
        out: response?.data?.value || 0,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, erroPacketOut: false }));
      }
    }
  };
  const getSpeedInterface = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, speed: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "ifSpeed",
          lastItem: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );

      setSpeedNow(formatTraffic(response?.data?.value || 0));
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, speed: false }));
      }
    }
  };
  const getPing = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, ping: true }));

    try {
      // --- 1. Busca as macros do host ---
      const macrosResponse = await apiCliente.post(
        "/client/hosts/macros",
        { hostId: filterData?.hostId },
        { signal },
      );

      const macros = macrosResponse?.data?.macros || [];

      // --- 2. Verifica se o ping está habilitado ---
      const pingHabilitado = macros?.find(
        (m) => m?.macro === "{$PING_HABILITADO}",
      );
      const isEnabled = pingHabilitado?.value === "1";
      setPingHabilitado(isEnabled);

      if (!isEnabled) {
        setPingDestinos([]);
        return;
      }

      // --- 3. Extrai apenas os macros de destino e monta índice IP → macro ---
      const destinoMacros = macros?.filter((m) =>
        m?.macro?.includes("DESTINO"),
      );

      // Map de IP/host (valor da macro) → macro, para lookup O(1) adiante
      const macroByIp = new Map(
        destinoMacros?.map((m) => [m?.value?.trim(), m]),
      );

      // --- 4. Busca latência (último valor) e perda de pacotes (média) em paralelo ---
      const [latencyResponse, packetLossResponse] = await Promise.all([
        apiCliente.post(
          "/cliente/zabbix/serieTemporal",
          {
            interface: filterData?.interfaceId,
            hostids: filterData?.hostId,
            itemsKeys: "latencia",
            lastItem: true,
            fabricante: filterData?.fabricante,
            funcao: filterData?.funcao,
            modelo: filterData?.modelo,
            dash: "overview",
          },
          { signal },
        ),
        apiCliente.post(
          "/cliente/zabbix/serieTemporal",
          {
            initial_date: dateInitial,
            final_date: finalDate,
            interface: filterData?.interfaceId,
            hostids: filterData?.hostId,
            itemsKeys: "perdaDePacotes",
            mean: true,
            fabricante: filterData?.fabricante,
            funcao: filterData?.funcao,
            modelo: filterData?.modelo,
            dash: "overview",
          },
          { signal },
        ),
      ]);

      let latencyData = [];
      const rawLatency = latencyResponse?.data;
      if (rawLatency) {
        if (Array.isArray(rawLatency)) {
          latencyData = rawLatency;
        } else if (typeof rawLatency === "object") {
          if ("itemid" in rawLatency) {
            latencyData = [rawLatency];
          } else {
            latencyData = Object.values(rawLatency).filter(
              (val) => val && typeof val === "object" && "itemid" in val,
            );
          }
        }
      }

      // --- 5. Constrói índice IP → dados de latência a partir do nome ---
      const latencyByIp = new Map();

      for (const item of latencyData) {
        const match = item?.name?.match(/\b(?:\d{1,3}\.){3}\d{1,3}\b/);
        const extractedIp = match ? match[0] : null;
        if (extractedIp) {
          latencyByIp?.set(extractedIp, { key: extractedIp, item });
        }
      }

      let packetLossData = [];
      const rawPacketLoss = packetLossResponse?.data;
      if (rawPacketLoss !== undefined && rawPacketLoss !== null) {
        if (Array.isArray(rawPacketLoss)) {
          packetLossData = rawPacketLoss;
        } else if (typeof rawPacketLoss === "object") {
          packetLossData = Object.entries(rawPacketLoss).map(
            ([key, value]) => ({
              name: key,
              value: Number(value),
            }),
          );
        } else {
          const firstMacroIp = destinoMacros?.[0]?.value?.trim();
          const plName =
            latencyData[0]?.name ||
            (firstMacroIp ? `perdaDePacotes[${firstMacroIp}]` : "");
          packetLossData = [
            {
              name: plName,
              value: Number(rawPacketLoss),
            },
          ];
        }
      }

      // --- 6. Busca ícones customizados e faz download das imagens em paralelo ---
      let iconsWithImages = [];
      try {
        const iconsResponse = await apiCliente.post(
          "/cliente/anexos/findMany",
          { type: "ping_icon" },
          { signal },
        );
        const pingIcons = iconsResponse?.data || [];

        iconsWithImages = await Promise.all(
          pingIcons.map(async (icon) => {
            try {
              const imgResponse = await apiCliente.post(
                "/cliente/anexos/download",
                { id: icon?.id },
                { responseType: "arraybuffer", signal },
              );
              const blob = new Blob([imgResponse?.data], {
                type: icon?.mimeType,
              });
              return { ...icon, imageUrl: URL.createObjectURL(blob) };
            } catch {
              return { ...icon, imageUrl: null };
            }
          }),
        );
      } catch (err) {
        console.error("Erro ao buscar ícones de ping:", err);
      }

      // Índice de ícones por descrição (lowercase, sem espaços extras) → O(1)
      const iconByDescription = new Map(
        iconsWithImages?.map((icon) => [
          icon?.descricao?.toLowerCase()?.trim(),
          icon,
        ]),
      );

      // --- 7. Resolve entrada de latência para um IP ou domínio ---
      // Ordem de prioridade (da mais confiável para a menos):
      const resolveLatencyEntry = (ip) => {
        // Tentativa 1: correspondência exata pelo IP extraído
        if (latencyByIp?.has(ip)) return latencyByIp?.get(ip);

        // Tentativa 2: o valor da macro aparece dentro do campo "name" do item
        // Cobre casos onde o Zabbix registra o domínio/IP no nome descritivo
        for (const item of latencyData) {
          if (item?.name?.toLowerCase()?.includes(ip?.toLowerCase())) {
            const match = item?.name?.match(/\\b(?:\\d{1,3}\\.){3}\\d{1,3}\\b/);
            return { key: match ? match[0] : null, item };
          }
        }

        // Tentativa 3: o IP extraído do nome não pertence a nenhuma outra macro
        // Cobre casos onde o Zabbix resolve o domínio para um IP diferente do configurado
        for (const [, entry] of latencyByIp) {
          const keyIp = entry?.key;
          if (keyIp && !macroByIp?.has(keyIp)) {
            return entry;
          }
        }

        return null;
      };

      // --- 8. Mapeia cada macro de destino com seus dados consolidados ---
      const destinos = destinoMacros?.map((macro) => {
        const ip = macro?.value?.trim();
        const descKey = macro?.description?.toLowerCase()?.trim();

        // Resolve latência e perda de pacotes
        const latencyEntry = resolveLatencyEntry(ip);
        const resolvedIp = latencyEntry?.key;

        const ping = formatPing(latencyEntry?.item?.value || 0);

        let packetLoss = 0;
        const plItem = packetLossData.find((pl) => {
          if (resolvedIp && pl?.name?.includes(resolvedIp)) return true;
          if (pl?.name?.toLowerCase()?.includes(ip?.toLowerCase())) return true;
          return false;
        });
        if (plItem) {
          packetLoss = plItem.value;
        }

        // Resolve ícone: customizado (por descrição) → fallback estático
        const customIcon = iconByDescription?.get(descKey);
        const image =
          customIcon?.imageUrl || getDestinoImage(macro?.description);

        return {
          description: macro?.description,
          value: ip,
          macro: macro?.macro,
          image,
          pingData: { ping, packetLoss },
        };
      });

      // --- 9. Atualiza estado revogando URLs de blob anteriores para evitar leak ---
      setPingDestinos((prevDestinos) => {
        prevDestinos.forEach((destino) => {
          if (destino?.image?.startsWith?.("blob:")) {
            URL.revokeObjectURL(destino?.image);
          }
        });
        return destinos;
      });
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal?.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, ping: false }));
      }
    }
  };
  const getPacketLoss = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, packetLoss: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "packetLoss",
          exactMatch: true,
          fillGap: 0,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );

      setPacketLoss(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, packetLoss: false }));
      }
    }
  };

  const getLatency = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, latency: true }));
    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          device: filterData?.device,
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          nameFilter: "latency",
          exactMatch: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "overview",
        },
        { signal },
      );

      setLatency(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, latency: false }));
      }
    }
  };
  const getAlerts = async (dateInitial, finalDate, signal) => {
    setLoadingDashOverview((prev) => ({ ...prev, alerts: true }));

    try {
      const response = await apiCliente.post(
        "/cliente/zabbix/items/alerts",
        {
          initial_date: dateInitial,
          final_date: finalDate,
          interface: filterData?.interfaceId,
          hostids: filterData?.hostId,
          // O clienteId é resolvido pelo token no backend, nunca enviado aqui
          servicoId: filterData?.serviceId,
        },
        { signal },
      );

      setRows(
        response?.data?.map((item, index) => {
          return {
            ...item,
            id: index,
          };
        }) || [],
      );
    } catch (error) {
      console.error(error);
    } finally {
      if (!signal.aborted) {
        setLoadingDashOverview((prev) => ({ ...prev, alerts: false }));
      }
    }
  };

  // busca série temporal de latência e perda de pacotes do destino clicado
  // overrideDates permite sobrescrever o range (ex: ao fazer zoom no modal)
  const getPingHistory = async (destino, signal, dateInitial, finalDate) => {
    if (!destino?.value) return;

    const ip = destino?.value;

    setPingHistoryLoading({ latency: true, packetLoss: true });
    try {
      const [latencyRes, packetLossRes] = await Promise.all([
        apiCliente.post(
          "/cliente/zabbix/serieTemporal",
          {
            hostids: filterData?.hostId,
            itemsKeys: `latencia[${ip}]`,
            exactMatch: true,
            initial_date: dateInitial,
            final_date: finalDate,
            fabricante: filterData?.fabricante,
            funcao: filterData?.funcao,
            modelo: filterData?.modelo,
            dash: "overview",
          },
          { signal },
        ),
        apiCliente.post(
          "/cliente/zabbix/serieTemporal",
          {
            hostids: filterData?.hostId,
            itemsKeys: `perdaDePacotes[${ip}]`,
            exactMatch: true,
            fillGap: 0,
            initial_date: dateInitial,
            final_date: finalDate,
            fabricante: filterData?.fabricante,
            funcao: filterData?.funcao,
            modelo: filterData?.modelo,
            dash: "overview",
          },
          { signal },
        ),
      ]);

      if (!signal?.aborted) {
        setPingHistoryData({
          latency: Array.isArray(latencyRes?.data) ? latencyRes?.data : [],
          packetLoss: Array.isArray(packetLossRes?.data)
            ? packetLossRes?.data
            : [],
        });
      }
    } catch (error) {
      if (!signal?.aborted) console.error(error);
    } finally {
      if (!signal?.aborted) {
        setPingHistoryLoading({ latency: false, packetLoss: false });
      }
    }
  };

  // abre o modal e busca os dados iniciais do destino selecionado
  const handlePingCardClick = (destino) => {
    setPingModalDestino(destino);
    setPingModalOpen(true);
    setPingHistoryData({ latency: [], packetLoss: [] });

    // calcula o range da mesma forma que fetchAllData
    let dateInitial = filterData?.initialDate;
    let finalDate = filterData?.finalDate;
    if (selectTime || selectTime === 0) {
      dateInitial = optionsTime?.[selectTime]?.value;
      finalDate = dayjs().set("second", 0).set("millisecond", 0).toDate();
    }

    getPingHistory(
      destino,
      controllerDashboard?.signal,
      dateInitial,
      finalDate,
    );
  };

  // zoom interno do modal: fixa o range e para de acompanhar o pai
  const handlePingModalZoom = (startDate, endDate) => {
    if (!pingModalDestino) return;
    setPingModalZoomed(true);
    // controller próprio para não ser cancelado pelo ciclo do pai
    const modalController = new AbortController();
    getPingHistory(
      pingModalDestino,
      modalController?.signal,
      dayjs(startDate)?.toDate(),
      dayjs(endDate)?.toDate(),
    );
  };

  // fecha o modal e limpa os dados de histórico
  const handlePingModalClose = () => {
    setPingModalOpen(false);
    setPingModalDestino(null);
    setPingHistoryData({ latency: [], packetLoss: [] });
    setPingHistoryLoading({ latency: false, packetLoss: false });
    setPingModalZoomed(false);
  };

  const fetchAllData = async () => {
    setCounter(null);
    stopCronometro();
    setLoadingCronometro(true);

    let dateInitial = filterData?.initialDate;
    let finalDate = filterData?.finalDate;

    if (selectTime || selectTime === 0) {
      dateInitial = optionsTime[selectTime]?.value;
      finalDate = dayjs().set("second", 0).set("millisecond", 0).toDate();
    }
    if (controllerDashboard) {
      controllerDashboard.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    const promises = [
      getDataTrafegoInput(dateInitial, finalDate, signal),
      getDataTrafegoOutput(dateInitial, finalDate, signal),
      getStatusInterface(dateInitial, finalDate, signal),
      getErrorPacketIn(dateInitial, finalDate, signal),
      getErrorPacketOut(dateInitial, finalDate, signal),
      getSpeedInterface(dateInitial, finalDate, signal),
      getPing(dateInitial, finalDate, signal),
      getPacketLoss(dateInitial, finalDate, signal),
      getLatency(dateInitial, finalDate, signal),
      getAlerts(dateInitial, finalDate, signal),
      getDataTrafegoInputNow(dateInitial, finalDate, signal),
      getDataTrafegoOutputNow(dateInitial, finalDate, signal),
      getOnuByService(signal, dateInitial, finalDate),
      getSessoesAtivas(dateInitial, finalDate, signal),
    ];

    // herda o ciclo de refresh do pai quando o modal está aberto e sem zoom fixado
    if (pingModalOpen && !pingModalZoomed && pingModalDestino) {
      promises.push(
        getPingHistory(pingModalDestino, signal, dateInitial, finalDate),
      );
    }

    await Promise.all(promises);
    if (!signal.aborted) {
      setLoadingCronometro(false);
      startCronometro();
    }
  };

  useEffect(() => {
    if (
      filterData?.interfaceId &&
      filterData?.hostId &&
      filterData?.initialDate &&
      filterData?.finalDate
    ) {
      toggleDrawer(false)();
      fetchAllData();
    } else {
      clearData();
    }
  }, [filterData]);
  function formatPacketLoss(value) {
    return `${Number(value).toFixed(1)}%`;
  }
  const CustomTooltipPackages = ({ active, payload, label }) => {
    if (!active || !payload || payload.length === 0) return null;

    const { clock, value } = payload[0].payload;

    return (
      <Box
        sx={{
          bgcolor: theme.palette.paletteCharts.lineCharts,
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        <Typography fontSize={"14px"}>
          {`Data: ${dayjs.unix(clock).format("DD/MM/YY HH:mm")}`}
        </Typography>

        <Stack direction={"row"} alignItems={"center"} gap={"4px"}>
          <Box
            sx={{
              bgcolor:
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ],
              width: "14px",
              height: "14px",
              borderRadius: "2px",
              border: `1px solid ${
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ]
              }`,
            }}
          />
          <Typography fontSize={"14px"}>
            Loss: {formatPacketLoss(value)}
          </Typography>
        </Stack>
      </Box>
    );
  };

  const CustomTooltipLatency = ({ active, payload, label }) => {
    if (!active || !payload || payload.length === 0) return null;

    const { clock, value } = payload[0].payload;

    return (
      <Box
        sx={{
          bgcolor: theme.palette.paletteCharts.lineCharts,
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        <Typography fontSize={"14px"}>
          {`Data: ${dayjs.unix(clock).format("DD/MM/YY HH:mm")}`}
        </Typography>

        <Stack direction={"row"} alignItems={"center"} gap={"4px"}>
          <Box
            sx={{
              bgcolor:
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ],
              width: "14px",
              height: "14px",
              borderRadius: "2px",
              border: `1px solid ${
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ]
              }`,
            }}
          />
          <Typography fontSize={"14px"}>
            Latência: {formatPing(value)}
          </Typography>
        </Stack>
      </Box>
    );
  };

  const CustomTooltipPower = ({ active, payload, label, rx = false }) => {
    if (!active || !payload || payload.length === 0) return null;

    const { clock, value } = payload[0].payload;
    const toFixedValue = value?.toFixed(2);

    return (
      <Box
        sx={{
          bgcolor: theme.palette.paletteCharts.lineCharts,
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        <Typography fontSize={"14px"}>
          {`Data: ${dayjs.unix(clock).format("DD/MM/YY HH:mm")}`}
        </Typography>

        <Stack direction={"row"} alignItems={"center"} gap={"4px"}>
          <Box
            sx={{
              bgcolor:
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ],
              width: "14px",
              height: "14px",
              borderRadius: "2px",
              border: `1px solid ${
                theme.palette.cardGraphic.graphColor[
                  value > 80
                    ? "red"
                    : value <= 80 && value > 40
                      ? "yellow"
                      : "green"
                ]
              }`,
            }}
          />
          <Typography fontSize={"14px"}>
            Potência: {rx ? -toFixedValue : toFixedValue}
          </Typography>
        </Stack>
      </Box>
    );
  };

  /**
   * Verifica se o serviço selecionado possui ONU associada
   * se existir, exibe as potências
   */

  const [onu, setOnu] = useState({});
  const [onuPower, setOnuPower] = useState({});
  const [selectedOnu, setSelectedOnu] = useState(null);
  const [loadingPower, setLoadingPower] = useState({
    rx: false,
    tx: false,
  });
  useEffect(() => {
    if (selectedOnu) {
      // Limpa os dados de power quando a ONU selecionada muda
      setOnuPower({ rx: [], tx: [] });

      // Obtem o range da consulta
      let dateInitial = filterData?.initialDate;
      let finalDate = filterData?.finalDate;

      if (selectTime || selectTime === 0) {
        dateInitial = optionsTime[selectTime]?.value;
        finalDate = dayjs().set("second", 0).set("millisecond", 0).toDate();
      }

      // Usa o signal do controllerDashboard existente
      const signal = controllerDashboard?.signal;

      // Busca os dados de power para a ONU selecionada
      getOnuByService(signal, dateInitial, finalDate);
    }
  }, [selectedOnu]);

  const getOnuByService = async (signal, dateInitial, finalDate) => {
    try {
      if (onu?.servicoId === filterData?.serviceId) {
        getOnuPowerRx(signal, selectedOnu, dateInitial, finalDate);
        getOnuPowerTx(signal, selectedOnu, dateInitial, finalDate);
        return;
      }

      const response = await apiCliente.post(
        "/cliente/findMany/hosts",
        { servicoId: filterData?.serviceId, onlyOnu: true },
        { signal },
      );

      if (response?.data?.length > 0) {
        const onuList = response.data;
        setOnu({ servicoId: filterData?.serviceId, onu: onuList });

        // Seleciona a primeira ONU por padrão
        setSelectedOnu(onuList[0]);
      } else {
        setOnu({ servicoId: filterData?.serviceId, onu: [] });
        setSelectedOnu(null);
      }
    } catch (error) {
      console.error(error);
      setSelectedOnu(null);
    }
  };

  const getOnuPowerRx = async (signal, selectedOnu, dateInitial, finalDate) => {
    try {
      loadingPower.rx = true;

      const onuItem = selectedOnu?.onuItem?.split(" - ");

      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          hostids: selectedOnu?.hostid,
          device: "onu",
          serialOnu: onuItem?.[1]?.trim(),
          usernameCliente: onuItem?.[2]?.trim(),
          posicaoOnu: onuItem?.[0]?.trim(),
          initial_date: dateInitial,
          final_date: finalDate,
          nameFilter: "receivedPower",
          fabricante: selectedOnu?.fabricante,
          funcao: selectedOnu?.funcao,
          modelo: selectedOnu?.modelo,
          dash: "onu",
        },
        { signal },
      );

      setOnuPower((prev) => ({ ...prev, rx: response?.data || [] }));
    } catch (error) {
      setOnuPower((prev) => ({ ...prev, rx: [] }));
      console.error(error);
    } finally {
      loadingPower.rx = false;
    }
  };

  const getOnuPowerTx = async (signal, selectedOnu, dateInitial, finalDate) => {
    try {
      loadingPower.tx = true;

      const onuItem = selectedOnu?.onuItem?.split(" - ");

      const response = await apiCliente.post(
        "/cliente/zabbix/serieTemporal",
        {
          hostids: selectedOnu?.hostid,
          device: "onu",
          serialOnu: onuItem?.[1]?.trim(),
          usernameCliente: onuItem?.[2]?.trim(),
          posicaoOnu: onuItem?.[0]?.trim(),
          initial_date: dateInitial,
          final_date: finalDate,
          nameFilter: "transmittedPower",
          fabricante: selectedOnu?.fabricante,
          funcao: selectedOnu?.funcao,
          modelo: selectedOnu?.modelo,
          dash: "onu",
        },
        { signal },
      );

      setOnuPower((prev) => ({ ...prev, tx: response?.data || [] }));
    } catch (error) {
      setOnuPower((prev) => ({ ...prev, tx: [] }));
      console.error(error);
    } finally {
      loadingPower.tx = false;
    }
  };

  const AutocompleteOnu = (
    <Autocomplete
      options={onu?.onu || []}
      value={selectedOnu}
      onChange={(event, newValue) => {
        setSelectedOnu(newValue);
      }}
      getOptionLabel={(option) => option?.onuItem || ""}
      sx={{
        width: 200,
      }}
      renderInput={(params) => (
        <Tooltip title={selectedOnu?.onuItem || ""}>
          <TextField
            {...params}
            label="Selecionar ONU"
            variant="outlined"
            size="small"
            sx={{
              fontSize: "0.75rem",
            }}
          />
        </Tooltip>
      )}
      disabled={!onu?.onu || onu?.onu?.length === 0}
    />
  );

  const PingCardSkeleton = () => (
    <Paper
      sx={{
        borderRadius: 3,
        minWidth: "200px",
        padding: "10px",
        display: "flex",
        flexDirection: "row",
        gap: 1,
        position: "relative",
        overflow: "hidden",
        background: theme?.palette?.gradient?.cardStatusOverview,
      }}
    >
      <Box>
        <Skeleton variant="circular" width={60} height={60} />
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
          <Skeleton
            variant="text"
            width={80}
            height={16}
            sx={{ marginBottom: 0 }}
          />
          <Skeleton
            variant="text"
            width={80}
            height={30}
            sx={{ marginTop: 0 }}
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Skeleton variant="text" width={80} height={16} />
          <Skeleton variant="rounded" width={80} height={20} />
        </Box>
      </Box>
    </Paper>
  );

  return (
    <>
      <Box sx={styles.container}>
        <Grid
          container
          spacing={1}
          columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
        >
          <Grid item xs={2} sm={4} md={6} lg={6}>
            <Grid
              container
              columns={{ xs: 2, sm: 4, md: 12, lg: 3, xl: 6, xxl: 6 }}
              spacing={1}
            >
              <Grid item xs={2} sm={2} md={4} lg={1}>
                <StatusComponent
                  loading={loadingDashOverview?.statusInterface}
                  status={statusInterface}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={4} lg={1}>
                <CardDataComponent
                  cardTile={"Tráfego (entrada)"}
                  cardValue={trafficNow?.in}
                  cardTextColor={"chip.main.waitingReview"}
                  typeIcon={2}
                  colorCard="inputData"
                  loading={loadingDashOverview?.trafficIn}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={4} lg={1}>
                <CardDataComponent
                  cardTile={"Tráfego (saída)"}
                  cardValue={trafficNow?.out}
                  cardTextColor={"chip.main.inProgress"}
                  colorCard="outputData"
                  typeIcon={2}
                  loading={loadingDashOverview?.trafficOut}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={4} lg={1}>
                <CardDataComponent
                  cardTile={"Pacotes com erros (entrada)"}
                  cardValue={errorPacketCount?.in}
                  cardTextColor={"chip.main.waitingReview"}
                  colorCard="inputData"
                  loading={loadingDashOverview?.erroPacketIn}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={4} lg={1}>
                <CardDataComponent
                  cardTile={"Pacotes com erros (saída)"}
                  cardValue={errorPacketCount?.out}
                  cardTextColor={"chip.main.inProgress"}
                  colorCard="outputData"
                  loading={loadingDashOverview?.erroPacketOut}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={4} lg={1}>
                <CardDataComponent
                  cardTile={"Velocidade"}
                  cardValue={speedNow}
                  cardTextColor={"chip.main.waitingReturn"}
                  typeIcon={1}
                  colorCard="speeData"
                  loading={loadingDashOverview?.speed}
                />
              </Grid>
            </Grid>
          </Grid>

          {sessoesAtivas?.length > 0 && (
            <Grid item xs={2} sm={4} md={6} lg={6} xl={6}>
              <Paper
                sx={{
                  ...styles.paper,
                  backgroundColor: theme.palette.background.paper,
                  position: "relative",
                  overflow: "hidden",
                }}
                elevation={theme.palette.mode === "dark" ? 0 : 3}
              >
                {loadingDashOverview?.sessoesAtivas && (
                  <LinearProgress sx={styles.linearProgress} />
                )}
                <Box sx={{ ...styles.containerComponent, width: "100%" }}>
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "30px",
                        height: "30px",
                        borderRadius: "5px",
                        backgroundColor:
                          theme?.palette?.cardGraphic?.graphColor?.green,
                      }}
                    >
                      <SettingsEthernetOutlined
                        sx={{
                          color: theme.palette.white.main,
                          fontSize: "20px",
                        }}
                      />
                    </Box>
                    <Typography
                      sx={{
                        ...styles.cardSubText,
                        color: theme?.palette?.cardGraphic?.graphColor?.green,
                      }}
                    >
                      Sessões Ativas
                    </Typography>
                  </Box>
                  <Box sx={{ width: "100%", height: "160px" }}>
                    <LineChartComponent
                      data={Array.isArray(sessoesAtivas) ? sessoesAtivas : []}
                      mainColor={theme?.palette?.cardGraphic?.graphColor?.green}
                      mainLineColor={
                        theme?.palette?.cardGraphic?.graphLineColor?.green
                      }
                      objectColorsLine={
                        sessoesAtivas?.[0]?.avg !== undefined
                          ? {
                              avg: theme?.palette?.cardGraphic?.graphColor
                                ?.green,
                              min: theme?.palette?.cardGraphic?.graphColor
                                ?.blue,
                              max: theme?.palette?.cardGraphic?.graphColor
                                ?.orange,
                            }
                          : false
                      }
                      formatValue={formatSessions}
                      isZoomEnabled={true}
                      onZoomChange={(range) => {
                        const startDate = dayjs.unix(range?.start);
                        const endDate = dayjs.unix(range?.end);
                        handleAplicarZoom(startDate, endDate);
                      }}
                      yOptions={{ tickFormatter: formatSessions }}
                      xOptions={{
                        tickFormatter: (clock) =>
                          dayjs.unix(clock).format("DD/MM HH:mm"),
                      }}
                    />
                  </Box>
                </Box>
              </Paper>
            </Grid>
          )}

          <Grid
            item
            columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
            flexGrow={1}
          >
            <Grid
              container
              columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
              flexGrow={1}
              spacing={1}
            >
              <Grid item xs={2} sm={4} md={6} lg={6} xl={3}>
                <DataGraphComponent
                  data={Array.isArray(trafficInput) ? trafficInput : []}
                  titleGraph={"Tráfego de entrada"}
                  colorType={2}
                  colorCardComponent={"blue"}
                  formatTraffic={formatTraffic}
                  loading={loadingDashOverview?.trafficIn}
                  handleAplicarZoom={handleAplicarZoom}
                  isZoomEnabled={true}
                />
              </Grid>
              <Grid item xs={2} sm={4} md={6} lg={6} xl={3}>
                <DataGraphComponent
                  data={Array.isArray(trafficOutput) ? trafficOutput : []}
                  titleGraph={"Tráfego de saída"}
                  colorType={4}
                  colorCardComponent={"orange"}
                  formatTraffic={formatTraffic}
                  loading={loadingDashOverview?.trafficOut}
                  handleAplicarZoom={handleAplicarZoom}
                  isZoomEnabled={true}
                />
              </Grid>
            </Grid>
          </Grid>
          {(loadingDashOverview?.ping
            ? pingHabilitado !== false
            : pingHabilitado && pingDestinos?.length > 0) && (
            <Grid item xs={2} sm={4} md={6} lg={6}>
              <Grid
                container
                spacing={1}
                columns={{
                  xs: 2,
                  sm: 4,
                  md: 6,
                  lg: pingDestinos?.length || 5,
                  xl: pingDestinos?.length || 5,
                  xxl: pingDestinos?.length || 5,
                }}
                flexGrow={1}
                alignItems="stretch"
              >
                {loadingDashOverview?.ping && pingDestinos?.length === 0
                  ? Array.from({ length: 5 }).map((_, index) => (
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        lg={1}
                        xl={1}
                        key={`ping-skeleton-${index}`}
                      >
                        <PingCardSkeleton />
                      </Grid>
                    ))
                  : pingDestinos?.map((destino, index) => (
                      <Grid
                        item
                        xs={2}
                        sm={2}
                        md={2}
                        lg={1}
                        xl={1}
                        key={destino?.macro || index}
                      >
                        <CardStatusComponent
                          cardName={destino?.description}
                          CardImage={destino?.image || NetworkPing}
                          value={destino?.pingData}
                          loading={loadingDashOverview?.ping}
                          onClick={() => handlePingCardClick(destino)}
                        />
                      </Grid>
                    ))}
              </Grid>
            </Grid>
          )}
          <Grid item xs={2} sm={4} md={6} lg={6}>
            <Grid
              container
              columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
              flexGrow={1}
              spacing={1}
            >
              <Grid item xs={2} sm={4} md={6} lg={6} xl={3}>
                <CardGraphComponent
                  loading={loadingDashOverview?.packetLoss}
                  titleGraph={"Perda de pacotes"}
                  data={Array.isArray(packetLoss) ? packetLoss : []}
                  icon={TrendingDownOutlined}
                  valueCard={formatPacketLoss(
                    Array.isArray(packetLoss)
                      ? packetLoss[packetLoss?.length - 1]?.value || 0
                      : 0,
                  )}
                  CustomTooltip={CustomTooltipPackages}
                  tickFormatter={formatPacketLoss}
                  maxValuebps={100}
                  iconColorCard={
                    Array.isArray(packetLoss)
                      ? packetLoss[packetLoss?.length - 1]?.value > 80
                        ? "red"
                        : packetLoss[packetLoss?.length - 1]?.value <= 80 &&
                            packetLoss[packetLoss?.length - 1]?.value > 40
                          ? "orange"
                          : "green"
                      : "green"
                  }
                  handleAplicarZoom={handleAplicarZoom}
                  isZoomEnabled={true}
                />
              </Grid>

              <Grid item xs={2} sm={4} md={6} lg={6} xl={3}>
                <CardGraphComponent
                  titleGraph={"Latência"}
                  data={Array.isArray(latency) ? latency : []}
                  icon={SpeedOutlined}
                  valueCard={formatPing(
                    Array.isArray(latency)
                      ? latency[latency?.length - 1]?.value || 0
                      : 0,
                  )}
                  tickFormatter={formatPing}
                  loading={loadingDashOverview?.latency}
                  CustomTooltip={CustomTooltipLatency}
                  iconColorCard={
                    Array.isArray(latency)
                      ? latency[latency?.length - 1]?.value > 100
                        ? "red"
                        : latency[latency?.length - 1]?.value <= 80 &&
                            latency[latency?.length - 1]?.value > 50
                          ? "orange"
                          : "green"
                      : "green"
                  }
                  handleAplicarZoom={handleAplicarZoom}
                  isZoomEnabled={true}
                />
              </Grid>
              {onu?.onu?.length > 0 && (
                <Grid item xs={2} sm={4} md={6} lg={6} xl={3}>
                  <CardGraphComponent
                    titleGraph={"Potência recebida"}
                    data={
                      Array.isArray(onuPower?.rx)
                        ? INVERSED_POWER_RX
                          ? onuPower?.rx?.map((item) => ({
                              ...item,
                              value: -item?.value,
                            }))
                          : onuPower?.rx
                        : []
                    }
                    icon={DownloadOutlined}
                    valueCard={`${
                      Array.isArray(onuPower?.rx)
                        ? onuPower?.rx[
                            onuPower?.rx?.length - 1
                          ]?.value?.toFixed(2) || 0
                        : 0
                    } dBm`}
                    maxValuebps={INVERSED_POWER_RX ? 40 : 0}
                    minValuebps={INVERSED_POWER_RX ? 0 : -40}
                    tickFormatter={formatPowerValue}
                    loading={loadingPower.rx}
                    CustomTooltip={<CustomTooltipPower rx={true} />}
                    iconColorCard={
                      Array.isArray(onuPower?.rx)
                        ? onuPower?.rx[onuPower?.rx?.length - 1]?.value <= -27
                          ? "red"
                          : onuPower?.rx[onuPower?.rx?.length - 1]?.value <= -25
                            ? "yellow"
                            : "green"
                        : "green"
                    }
                    topRightItem={AutocompleteOnu}
                    handleAplicarZoom={handleAplicarZoom}
                    isZoomEnabled={true}
                  />
                </Grid>
              )}
              {onu?.onu?.length > 0 && (
                <Grid item xs={2} sm={4} md={6} lg={6} xl={3}>
                  <CardGraphComponent
                    titleGraph={"Potência transmitida"}
                    data={Array.isArray(onuPower?.tx) ? onuPower?.tx : []}
                    icon={PublishOutlined}
                    valueCard={`${
                      Array.isArray(onuPower?.tx)
                        ? onuPower?.tx[
                            onuPower?.tx?.length - 1
                          ]?.value?.toFixed(2) || 0
                        : 0
                    } dBm`}
                    tickFormatter={(value) => `${value?.toFixed(0)} dBm`}
                    loading={loadingPower.tx}
                    CustomTooltip={CustomTooltipPower}
                    iconColorCard={
                      Array.isArray(onuPower?.tx)
                        ? onuPower?.tx[onuPower?.tx?.length - 1]?.value > 100
                          ? "red"
                          : onuPower?.tx[onuPower?.tx?.length - 1]?.value <=
                                80 &&
                              onuPower?.tx[onuPower?.tx?.length - 1]?.value > 50
                            ? "orange"
                            : "green"
                        : "green"
                    }
                    topRightItem={AutocompleteOnu}
                    handleAplicarZoom={handleAplicarZoom}
                    isZoomEnabled={true}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs={2} sm={4} md={6} lg={6}>
            <Grid
              container
              columns={{ xs: 2, sm: 4, md: 6, lg: 6, xl: 6, xxl: 6 }}
            >
              <Grid item xs={2} sm={4} md={6} lg={6}>
                <Paper
                  sx={{
                    ...styles.paperDatagrid,
                    ...(rows?.length > 16 && { height: "500px" }),
                  }}
                  elevation={theme.palette.mode == "dark" ? 0 : 3}
                >
                  {loadingDashOverview?.alerts && (
                    <LinearProgress sx={styles.linearProgress} />
                  )}
                  <Typography variant="h6" sx={styles.titleDatagrid}>
                    Alertas - Visão Geral
                  </Typography>
                  <Divider />
                  <Box
                    sx={{
                      display: "flex",
                      ...(rows?.length > 16 && { height: "445px" }),
                    }}
                  >
                    <DatagridComponent
                      title={"Alertas - Visão Geral"}
                      rows={rows}
                      columns={columns}
                      options={{
                        getRowClassName: (params) =>
                          clsx(
                            {
                              "onGoing-row": !params.row.recoveryDate,
                              [`severity-${params.row.severity}`]:
                                !params.row.recoveryDate,
                            },
                            Number(params?.indexRelativeToCurrentPage) % 2 === 1
                              ? "linha-impar"
                              : "linha-par",
                          ),
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      {/* modal de histórico de ping por destino */}
      <Dialog
        open={pingModalOpen}
        onClose={handlePingModalClose}
        fullWidth
        maxWidth="md"
        PaperProps={{ sx: styles.pingModalDialog }}
      >
        {/* cabeçalho com ícone do destino e botão fechar */}
        <Box sx={styles.pingModalHeader}>
          <Box sx={styles.pingModalHeaderIcon}>
            {typeof pingModalDestino?.image === "string" ? (
              <img
                src={pingModalDestino?.image}
                alt={pingModalDestino?.description || "destino"}
                style={{ width: 28, height: 28, objectFit: "contain" }}
              />
            ) : (
              <NetworkPing sx={{ fontSize: 28 }} />
            )}
            <Typography sx={styles.pingModalTitle}>
              {pingModalDestino?.description || ""}
            </Typography>
          </Box>
          <IconButton onClick={handlePingModalClose} size="small">
            <CloseOutlined />
          </IconButton>
        </Box>

        <DialogContent sx={styles.pingModalContent}>
          {/* gráfico de latência do destino selecionado */}
          <Paper
            variant="outlined"
            sx={{ p: 0, overflow: "hidden", borderRadius: 4 }}
          >
            <CardGraphComponent
              loading={pingHistoryLoading?.latency}
              titleGraph={`Latência — ${pingModalDestino?.description || ""}`}
              data={
                Array.isArray(pingHistoryData?.latency)
                  ? pingHistoryData?.latency
                  : []
              }
              icon={SpeedOutlined}
              valueCard={formatPing(
                Array.isArray(pingHistoryData?.latency)
                  ? pingHistoryData?.latency?.[
                      pingHistoryData?.latency?.length - 1
                    ]?.value || 0
                  : 0,
              )}
              tickFormatter={formatPing}
              CustomTooltip={CustomTooltipLatency}
              iconColorCard={
                Array.isArray(pingHistoryData?.latency) &&
                pingHistoryData?.latency?.[pingHistoryData?.latency?.length - 1]
                  ?.value > 100
                  ? "red"
                  : "green"
              }
              handleAplicarZoom={handlePingModalZoom}
              isZoomEnabled={true}
            />
          </Paper>

          {/* gráfico de perda de pacotes do destino selecionado */}
          <Paper
            variant="outlined"
            sx={{ p: 0, overflow: "hidden", borderRadius: 4 }}
          >
            <CardGraphComponent
              loading={pingHistoryLoading?.packetLoss}
              titleGraph={`Perda de Pacotes — ${pingModalDestino?.description || ""}`}
              data={
                Array.isArray(pingHistoryData?.packetLoss)
                  ? pingHistoryData?.packetLoss
                  : []
              }
              icon={TrendingDownOutlined}
              valueCard={formatPacketLoss(
                Array.isArray(pingHistoryData?.packetLoss)
                  ? pingHistoryData?.packetLoss?.[
                      pingHistoryData?.packetLoss?.length - 1
                    ]?.value || 0
                  : 0,
              )}
              tickFormatter={formatPacketLoss}
              CustomTooltip={CustomTooltipPackages}
              maxValuebps={100}
              iconColorCard={
                Array.isArray(pingHistoryData?.packetLoss) &&
                pingHistoryData?.packetLoss?.[
                  pingHistoryData?.packetLoss?.length - 1
                ]?.value > 80
                  ? "red"
                  : pingHistoryData?.packetLoss?.[
                        pingHistoryData?.packetLoss?.length - 1
                      ]?.value > 40
                    ? "orange"
                    : "green"
              }
              handleAplicarZoom={handlePingModalZoom}
              isZoomEnabled={true}
            />
          </Paper>
        </DialogContent>
      </Dialog>
    </>
  );
}
